import React from "react";
// import ScrollToTop from "../../components/ScrollToTop/ScrollTopTop";
import "./outreact_detail.css";

function OutreachDetail() {
  return (
    <>
      <section id="outreach_house" className="outreach_section">
        <h2 className="outreach_head">LOCAL COMMUNITY MISSIONS</h2>
        <div className="wrapper container">
          <div id="higway_house" className="outreach_house_main">
            <h2>Highway House</h2>
            <p>
              One of the major projects we run as a church is, Highway House –
              once a homeless shelter that accommodated up 40 residents per
              night, post COVID, it now functions as a day centre for those who
              are homeless or at risk of homelessness. The day centre is open
              every Tuesday and Friday between 11am – 3pm on our church
              premises; where our support workers and volunteers offer a helping
              hand to those who visit. This ranges from teas and coffee’s,
              showering, providing clean clothes and bedding to immigration
              support, health care needs and employment and housing support.{" "}
              <br />
              <br />
              Highway House was birthed out of an evangelism outreach session
              that took place in the winter of 2009. During this session Pastor
              that took place in the winter of 2009. During this session Pastor
              Dorcas came across two homeless men, Chris and Lec, whom she
              approached to share the gospel she then went a step further to
              invite them to our church premises to meet with Pastor Alex. At
              this meeting they got to know them more, they spoke about their
              backgrounds, their families and the circumstances that lead them
              to homelessness and prayed with them concerning their needs.{" "}
              <br /> <br />
              After this meeting Pastor sensed there was a true and urgent need
              to help these men; to gain confidence in themselves and restore
              their dignity, to help fight the addiction of alcohol, and to
              cater to their physical needs of food, clothing and cleaning
              facilities but most of all for the good news of salvation. This
              led to us converting one of our toilets in church into a shower
              room, providing food and companionship to these men. As we
              supported them we shared the faith and many assimilated into our
              church, got baptised and worshiped. <br />
              <br />
              Fast forward to today this present day we have helped almost 1000
              people have been helped with shelter, food and counselling, along
              with the opportunity for much needed companionship with others. To
              find out more visit our website – HH link.
            </p>
          </div>
        </div>
      </section>
      <section id="youth_club" className="outreach_section">
        <div className="wrapper container">
          <h2>Highway Youth Club</h2>
          <p>Highway youth club was established in ..</p>
          <h2></h2>
        </div>
      </section>

      <section id="centryeducation" className="outreach_section">
        <div className="wrapper container">
          <h2>21st Century Education</h2>
          <p>
            The 21st Century Skills Academy is a supplementary Saturday school
            that teaches Maths, English and Science. It aims to create an
            enabling learning environment where Christian children develop
            cutting edge skills relevant for the 21st Century. We tailor-make
            lessons designed to help children achieve their full potentials,
            encourage high student expectations and we are results driven in our
            approach. Mission Statement:
          </p>
          <ul>
            <li>
              Developing cutting edge skills for Christian Children for the 21st
              century.
            </li>
            <li>
              Train up the child the way they should go - Proverbs 22:6; Hebrews
              12:11.
            </li>
          </ul>
        </div>
      </section>
      <section id="outreach_detail_shift" className="outreach_section">
        <div className="wrapper container">
          <h2>SHIFT</h2>
          <p>
            Showing how individuals transform is a youth and young adult’s
            fellowship, lead by the youth and young adults of Highway of
            Holiness church. It was birthed after a power packed retreat that
            took place in the summer of 2019 and since then has impacted the
            lives of many young people. From conducting services in person and
            online to launching a podcast discussing current day issues that
            face this generation. SHIFT is a fellowship that seeks to bring
            light, wisdom and guidance from Gods word to equip the worlds next
            generation of movers and shakers. <br /> <br />
            Look out for more updates on upcoming events and services.
            <br />
          </p>
          <p>Connect with us on our social platforms</p>
          <p>
            Twitter -{" "}
            <a
              className="outreach_detail_social"
              href="https://twitter.com/shift_hy"
              target="_blank"
              rel="noopener noreferrer"
            >
              @shift_hy
            </a>
          </p>
          <p>
            IG -{" "}
            <a
              className="outreach_detail_social"
              href="https://www.instagram.com/shift.hy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              @shift.hy
            </a>
          </p>
        </div>
      </section>

      <section id="outreach_detail_klm" className="outreach_section">
        <h2 className="outreach_head">Global Missions</h2>
        <div className="wrapper container">
          <h2>KLM</h2>
          Kingdom Lifestyle Mission (KLM) provides free supplementary education
          for underprivileged children in 5 countries across the world. KLM runs
          free weekly Saturday schools and vacation classes during school
          holidays. The goal is to help children in deprived communities by
          providing them with extra lessons in order to bridge the gap between
          them and their more affluent or privileged counterparts. KLM also
          freely provides the children in attendance with learning materials,
          stationery and a meal. In exceptional cases KLM put children who have
          had to drop out of school back into full time education. As a charity
          we seek to inspire, engage and create opportunities for
          underprivileged children across the globe. This international charity
          was birthed by the Highway of Holiness Church which is a UK registered
          charity.
          <br /> <br />
          KLM currently operates in Ghana, Ethiopia, Bulgaria, South Sudan and
          Pakistan.
        </div>
      </section>

      <section id="outreach_pakistan" className="outreach_section">
        <div className="wrapper container">
          <h2>Highway of Holiness – Pakistan</h2>
          <p>
            We currently have a branch of Highway of Holiness church in
            Pakistan.
          </p>
        </div>
      </section>

      <section id="outreach_alliance" className="outreach_section">
        <div className="wrapper container">
          <h2>Kingdom Culture Alliance</h2>
          <p>
            Kingdom Culture Alliance (KCA) is a forum for leaders and ministers
            who desire to build their character and capacity for the advancement
            of the Kingdom of God. Today Kingdom Culture Alliance leader’s
            conference has crossed boarders reaching many nations including
            Ghana, France, Poland, India and Pakistan.
          </p>
        </div>
      </section>

      <section id="outreach_affiliated" className="outreach_section">
        <div className="wrapper container">
          <h2>Affiliated Churches/Mission Support</h2>
          <p>
            As a church we acknowledge that we are one part of the body of
            Christ. The bible instructs us to work together in harmony,
            supporting one another, praying for one another and being each
            other’s keeper. So we ensure our resources are shared with fellow
            labourers in Christ across the world. We currently give to churches
            in India, Kenya, Liberia, Ghana, Philippines, Nigeria, Poland,
            Nicaragua.
          </p>
        </div>
      </section>
      {/* <ScrollToTop /> */}
    </>
  );
}

export default OutreachDetail;
